import styled from 'styled-components'

export const ReportCardContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 1px solid var(--gray200);
  border-radius: 8px;
  padding: 16px;
`

export const ReportCardContent = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 16px;
`

export const ReportCardContainerTitle = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 16px;
`

export const ReportCardContainerTitleIcon = styled.section`
  min-width: 24px;
  min-height: 24px;
`

export const ReportCardContainerBulletPoints = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
